import { EventsApi } from "./EventsApi";
import { MenuApi } from "./MenuApi";
import { SmallAnnouncesApi } from "./SmallAnnouncesApi";
import axios, { AxiosInstance, AxiosError } from "axios";
import { StaticApi } from "./StaticApi";
import { NewsApi } from "./NewsApi";
import { JobsApi } from "./JobsApi";
import { UserApi } from "./UserApi";
import { ImageApi } from "./ImageApi";
import { DocumentReperesApi } from "./DocumentReperesApi";

export class PatekApi {
  news: NewsApi;
  jobs: JobsApi;
  events: EventsApi;
  menus: MenuApi;
  smallAnnounces: SmallAnnouncesApi;
  axios: AxiosInstance;
  axiosOptions: any;
  static: StaticApi;
  user: UserApi;
  image: ImageApi;
  documentReperes: DocumentReperesApi;
  private errorHanlders: { (data?: AxiosError): void }[] = [];
  constructor() {
    this.axios = axios.create();
    this.axiosOptions = {};
    this.jobs = new JobsApi((data) => this.errorCallback(data), this.axiosOptions);
    this.events = new EventsApi((data) => this.errorCallback(data), this.axiosOptions);
    this.news = new NewsApi((data) => this.errorCallback(data), this.axiosOptions);
    this.menus = new MenuApi((data) => this.errorCallback(data), this.axiosOptions);
    this.static = new StaticApi((data) => this.errorCallback(data), this.axiosOptions);
    this.user = new UserApi((data) => this.errorCallback(data), this.axiosOptions);
    this.image = new ImageApi((data) => this.errorCallback(data), this.axiosOptions);
    this.documentReperes = new DocumentReperesApi(
      (data) => this.errorCallback(data),
      this.axiosOptions
    );
    this.smallAnnounces = new SmallAnnouncesApi(
      (data) => this.errorCallback(data),
      this.axiosOptions
    );
    this.errorHanlders = [];
  }
  setToken(token) {
    this.axiosOptions["headers"] = { Authorization: "Bearer " + token };
  }
  onError(handler) {
    this.errorHanlders.push(handler);
  }
  errorCallback(e: AxiosError) {
    this.errorHanlders.slice(0).forEach((handler) => handler(e));
  }
}
